enum PickingStatus {
  TO_DO = 'TO_DO',
  PARTIAL = 'PARTIAL',
  COMPLETE = 'COMPLETE',
}

export default PickingStatus;
